import { useEffect, useState } from 'react'
import { SecondaryButton } from '../../../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import { PrimaryButton } from '../../../../../components/ui_kit_quickMD/primary-button/primarybutton'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AddRemark = ({ remarkValue, onChange, onCancel, onRemarkAdd, isEditMode, onEditRemark }) => {
  const [initialRemarkValue, setInitialRemarkValue] = useState('')

  useEffect(() => {
    setInitialRemarkValue(remarkValue)
  }, [])

  const onPrimaryButtonPressed = () => {
    if (isEditMode) {
      if (initialRemarkValue !== remarkValue) {
        onEditRemark?.()
      } else {
        onCancel?.()
      }
    } else {
      onRemarkAdd?.()
    }
  }

  return (
    <section className='textarea-container'>
      <label htmlFor='reamrkText'>
        <header className='textarea-header'>{isEditMode ? 'Edit visit remark' : 'New visit remark'}</header>
        <textarea
          value={remarkValue}
          onChange={onChange}
          autoComplete='off'
          placeholder='Type something...'
          className='textarea-remark'
          name='remark'
          id='reamrkText'
        />
      </label>
      <div className='textarea-remark-actions'>
        {/*
         // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
        <SecondaryButton btnText='Cancel' onPress={onCancel} />
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <PrimaryButton btnText='Save' onPress={onPrimaryButtonPressed} />
      </div>
    </section>
  )
}
